import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-jquidialog',
	templateUrl:'./JQUIDialogPage.html',
	styles: [],
	styleUrls:['./JQUIDialogPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDialogPage
{
	mdContent_195 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.dialog.JQUIDialog;
\`\`\``;
	mdContent_196 = `\`\`\`java
new JQUIDialog&lt;&gt;(String title)
\`\`\``;
	mdContent_197 = `\`\`\`java
var dialog = new JQUIDialog<>("Confirm");
dialog.getOptions().setModal(true);
dialog.getOptions().setWidth(400);
dialog.setText("Are you sure?");
\`\`\``;
}
